export default __webpack_public_path__ + "bg-404.png";